import { NgModule } from '@angular/core';
import { NAMESPACE_ONBOARDING } from '@epicuro-next/constants/rule-engine/onboarding-rules';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { LocalStorageService } from '@epicuro-next/platform/storage';
import { storageMetaReducer } from '@epicuro-next/state/meta-reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  OnboardingEffects,
  onboardingFeatureKey,
  ONBOARDING_STORAGE_KEY_VALUE,
  ONBOARDING_VIEWED_VALUE_KEY,
  reducer,
} from './state';
import {
  ONBOARDING_CONFIG_TOKEN,
  ONBOARDING_STORAGE_KEY,
  ONBOARDING_STORAGE_KEYS,
} from './state/tokens';

export function getOnboardingFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: LocalStorageService,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
    ],
  };
}

@NgModule({
  imports: [
    ConfigurationModule.forFeature(NAMESPACE_ONBOARDING),
    StoreModule.forFeature(
      onboardingFeatureKey,
      reducer,
      ONBOARDING_CONFIG_TOKEN,
    ),
    EffectsModule.forFeature([OnboardingEffects]),
  ],
  providers: [
    {
      provide: ONBOARDING_STORAGE_KEY,
      useValue: ONBOARDING_STORAGE_KEY_VALUE,
    },
    {
      provide: ONBOARDING_STORAGE_KEYS,
      useValue: [ONBOARDING_VIEWED_VALUE_KEY],
    },
    {
      provide: ONBOARDING_CONFIG_TOKEN,
      deps: [
        ONBOARDING_STORAGE_KEYS,
        ONBOARDING_STORAGE_KEY,
        LocalStorageService,
      ],
      useFactory: getOnboardingFactoryConfig,
    },
  ],
})
export class OnboardingStateModule {}
